module.exports = __webpack_public_path__ + "img/maple-logo.2c0c31f8.png";